import { useTranslation } from 'react-i18next'
import styles from './playerLevelTable.module.scss'
import { useCountries } from 'hooks/use-countries'
import { useMemo } from 'react'
import { Player } from 'types/global'
import { StratumDataItem } from '../types'
import { getDataItem, getFallbackStats } from './utils'
import StatsNote from '../stats-note/StatsNote'

interface Props {
  profile: Player
}

const PlayerLevelTable = ({ profile }: Props) => {
  const { t } = useTranslation('strPlayerLevel')
  const { getCountryName } = useCountries()

  const dataItems: StratumDataItem[] = useMemo(() => {
    const stats = profile?.demographicStats ?? []

    if (!stats?.length) stats.push(...getFallbackStats(profile))

    return (
      stats
        .map(stat => getDataItem(stat, { t, getCountryName }))
        .filter(Boolean) as StratumDataItem[]
    ).sort((a, b) => a.order - b.order)
  }, [t, profile, getCountryName])

  return (
    <>
      <table className={styles.table}>
        <tbody>
          {dataItems.map(({ label, value }, i) => (
            <tr key={i} className={styles.row}>
              <th className={styles.label}>{label}</th>
              <td className={styles.data}>{profile?.isVerifiedSingles ? value : '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <StatsNote isVerified={profile?.isVerifiedSingles} />
    </>
  )
}

export default PlayerLevelTable
